import React, { useEffect, useState } from 'react'
import { Form, Input, Select } from 'antd';
import { DownOutlined } from '@ant-design/icons'
import { GetCurrentCurrencyRateApi } from '../../../../api/request/wallet/cashdeposit';
import { GetPaymentGatewayApi } from '../../../../api/request/wallet/deposit';
import UpiDeposit from './components/UpiDeposit';
import UsdtTrc20 from './components/UsdtTrc20';
import Stripe from './components/Stripe';
import CreditDebitCard from './components/CreditDebitCard';
import { GetMT5AccountsApi } from '../../../../api/request/transfer';
import DepositRequest from './DepositRequest';
import { useSelector } from 'react-redux';
import ZaroPayMobile from './components/ZaroPayMobile.jsx';
import { handleApiError } from '../../../../utils/handleApiError.js';
import { GetTermsByTermsApi } from '../../../../api/request/common.js';
import { YourWallet } from '../../../../api/request/dashboard.js';
import Balance from '../../../../assets/Balance.jsx';
import Cregis from './components/Cregis.jsx';
import UniPayment from './components/UniPayment.jsx';
import Match2Pay from './components/Match2Pay.jsx';
import CashDepositMobile from './components/CashDepositMobile.jsx';

const DepositMobile = ({ setPaymentMethod, paymentMethod }) => {
    const [form] = Form.useForm();
    const { userDetails } = useSelector(state => state?.user);
    const [paymentGateways, setPaymentGateways] = useState([]);
    const [paymentGatewaysMethods, setPaymentGatewaysMethods] = useState([]);
    const [currencyRate, setCurrencyRate] = useState(null);
    const [accounts, setAccounts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [amount, setAmount] = useState(0);
    const [step, setStep] = useState(1);
    const [isRefresh, setIsRefresh] = useState(false);
    const [isCashDeposit, setIsCashDeposit] = useState(false)
    const [tncFileUrl, setTncFileUrl] = useState('');
    const [selectedAccount, setSelectedAccount] = useState('wallet');
    const [walletBalance, setWalletBalance] = useState(0)
    const [validation, setValidation] = useState('');

    const getPaymentGateway = async () => {
        setIsLoading(true);
        try {
            const { data } = await GetPaymentGatewayApi(1);
            if (data?.success) {
                setPaymentGateways(data?.data);
                // default-select the first payment method
                if (data?.data && data.data.length > 0) {
                    setPaymentMethod(data.data[0]?.name || null);
                }

                const methods = [];

                for (let i = 0; i < data?.data.length; i++) {
                    const gateway = data?.data[i];
                    switch (gateway.name) {
                        case "Cregis":
                            methods.push(
                                {
                                    label: 'USDT_TRC20', methodValue: 0, ...gateway, paymentLogoUrl: "https://crm.upforex.live/LogoImage/Crypto.png"
                                },
                                { label: 'USDT_BEP20', methodValue: 1, ...gateway, paymentLogoUrl: "https://crm.upforex.live/LogoImage/BEP_Logo.jpg" },
                                { label: 'USDT_ERC20', methodValue: 2, ...gateway, paymentLogoUrl: "https://crm.upforex.live/LogoImage/ERC_20.jpg" },
                            );
                            break;

                        case "Unipayment":
                            methods.push(
                                { label: 'Card Payment', methodValue: 4, ...gateway, paymentLogoUrl: "https://crm.upforex.com/LogoImage/stripe.png" }
                            );
                            break;

                        case "Match2Pay":
                            methods.push(
                                { label: 'USDT_ERC20', methodValue: 5, ...gateway, paymentLogoUrl: "https://crm.upforex.com/LogoImage/ERC_20.jpg" }
                            );
                            break;

                        default:
                            methods.push({ label: gateway.name, methodValue: gateway.value || gateway.id, ...gateway, })
                            break;
                    }
                }

                // Optional: Remove duplicate methods
                const uniqueMethods = methods.filter(
                    (m, i, a) => a.findIndex(x => x.methodValue === m.methodValue) === i
                );
                setPaymentMethod(uniqueMethods[0]?.methodValue || null);
                setPaymentGatewaysMethods(uniqueMethods);

            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setIsLoading(false);
        }
    }

    const getCurrentCurrencyRate = async () => {
        try {
            const { data } = await GetCurrentCurrencyRateApi();
            if (data?.success) setCurrencyRate(data?.data);
        } catch (error) {
        }
    }

    const getAccounts = async () => {
        setIsLoading(true);
        try {
            const { data } = await GetMT5AccountsApi(true);
            if (data?.success) {
                setAccounts(data?.data?.filter((account) => account?.isLive));
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setIsLoading(false);
        }
    }

    // const fetchTncFileUrl = async () => {
    //     try {
    //         const { data } = await GetTermsByTermsApi(1);
    //         if (data?.success && data?.data?.fileURL) {
    //             setTncFileUrl(data.data.fileURL);
    //         }
    //     } catch (err) { }
    // }

    useEffect(() => {
        getPaymentGateway();
        getCurrentCurrencyRate();
        getAccounts();
        // fetchTncFileUrl();
        getWalletBalance();
    }, []);

    // const validateAmount = (_, value) => {
    //     if (!value) {
    //         return Promise.reject(new Error('Please enter amount.'));
    //     }

    //     if (Number(value) <= 0) {
    //         return Promise.reject(new Error('Please enter a valid amount.'));
    //     }

    //     if (amount < paymentMethod?.minAmount) {
    //         return Promise.reject(new Error(`Amount must be at least $${paymentMethod?.minAmount}.`));
    //     }

    //     if (amount > paymentMethod?.maxAmount) {
    //         return Promise.reject(new Error(`Amount cannot exceed $${paymentMethod?.maxAmount}.`));
    //     }

    //     return Promise.resolve();
    // };


    const validateAmount = (_, value) => {
        const depositPay = paymentGateways.find((item) => item?.name === paymentMethod)
        const numericValue = parseFloat(value);
        const min = parseFloat(depositPay?.minAmount);
        const max = parseFloat(depositPay?.maxAmountminAmount);
        const usdValue = depositPay?.name === "Cash Deposit" ? amount : numericValue;

        if (!value) {
            setValidation('Please deposit enter amount');
            return Promise.reject("Please enter deposit amount");
        }
        if (isNaN(numericValue)) {
            setValidation('Please enter valid number');
            return Promise.reject("Please enter valid number");
        }
        if (usdValue < min) {
            setValidation(`Minimum deposit is ${depositPay.minAmount}`);
            return Promise.reject(`Minimum deposit is ${depositPay.minAmount}$`);
        }
        if (usdValue > max) {
            setValidation(`Maximum deposit is ${depositPay.maxAmount}`);
            return Promise.reject(`Maximum deposit is ${depositPay.maxAmount}$`);
        }
        setValidation('');
        return Promise.resolve();
    }
    const handleSubmit = (values) => {
        if ((values?.amount || values?.inrAmount) && values?.paymentMethod) setStep(2);
    }

    const resetAll = () => {
        form.resetFields();
        setAmount(0);
        setPaymentMethod(null);
        setStep(1);
        setIsRefresh(true);
    }

    useEffect(() => {
        if (paymentMethod === "Cash Deposit") {
            form.setFieldValue('inrAmount', amount * currencyRate?.targetCurrencyRate)
            setIsCashDeposit(true)
        } else {
            setIsCashDeposit(false)
        }
        setStep(2);
    }, [paymentMethod])

    const getWalletBalance = async () => {
        try {
            const { data } = await YourWallet(userDetails?._id);
            if (data?.success) {
                setWalletBalance(data?.data?.walletAmount);
            }
        } catch (error) {
            handleApiError(error);
        }
    }



    const selectedPayment = paymentGatewaysMethods.find((item) => item?.methodValue === paymentMethod)

    const renderStep = () => {
        switch (selectedPayment?.name) {
            case "Wire Transfer":
                return <CashDepositMobile paymentMethod={selectedPayment} amount={amount} resetAll={resetAll} tncFileUrl={tncFileUrl} loginTerminalId={selectedAccount} validateAmount={validation} />;
            case "UPI":
                return <UpiDeposit amount={amount} paymentMethod={selectedPayment} resetAll={resetAll} tncFileUrl={tncFileUrl} loginTerminalId={selectedAccount} validateAmount={validation} />;
            case "Crypto":
                return <UsdtTrc20 amount={amount} paymentMethod={selectedPayment} resetAll={resetAll} tncFileUrl={tncFileUrl} loginTerminalId={selectedAccount} validateAmount={validation} />;
            case "Stripe":
                return <Stripe amount={amount} paymentMethod={selectedPayment} accounts={accounts} resetAll={resetAll} tncFileUrl={tncFileUrl} loginTerminalId={selectedAccount} validateAmount={validation} />;
            case "Network":
                return <CreditDebitCard amount={amount} paymentMethod={selectedPayment} accounts={accounts} resetAll={resetAll} tncFileUrl={tncFileUrl} loginTerminalId={selectedAccount} validateAmount={validation} />;
            case "ZaroPay":
                return <ZaroPayMobile amount={amount} paymentMethod={selectedPayment} accounts={accounts} resetAll={resetAll} tncFileUrl={tncFileUrl} loginTerminalId={selectedAccount} validateAmount={validation} />;
            case "Match2Pay":
                return <Match2Pay amount={amount} paymentMethod={selectedPayment} accounts={accounts} loginTerminalId={selectedAccount} validateAmount={validation} resetAll={resetAll} />;
            case "Cregis":
                return <Cregis amount={amount} paymentMethod={selectedPayment} accounts={accounts} loginTerminalId={selectedAccount} validateAmount={validation} resetAll={resetAll} />;
            case "Unipayment":
                return <UniPayment amount={amount} paymentMethod={selectedPayment} accounts={accounts} loginTerminalId={selectedAccount} validateAmount={validation} resetAll={resetAll} />;
            default:
                return null;
        }
    }

    return (
        <div className="mobile-dashboard min-h-screen">
            <div className='mb-4'>
                <div className="mb-4">
                    <div className="relative">
                        <Form form={form} layout='vertical' className='space-y-5' onFinish={handleSubmit}>
                            <Select
                                value={paymentMethod}
                                onChange={setPaymentMethod}
                                className="w-full !bg-white rounded-xl"
                                size="large"
                                suffixIcon={<div className="flex items-center justify-center h-full w-full"><DownOutlined className="text-gray-400 bg-[#F5F9FD] p-2.5 rounded-lg" /></div>}
                                placeholder="Select Payment Method"
                                popupClassName="custom-select-dropdown"
                                dropdownAlign={{ offset: [0, 0] }}
                                dropdownStyle={{
                                    borderRadius: '16px',
                                    padding: '8px',
                                    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
                                    border: 'none',
                                    marginTop: '-10px'
                                }}
                            >
                                {paymentGatewaysMethods.map(item => (
                                    <Select.Option
                                        key={item?.methodValue}
                                        value={item?.methodValue}
                                        label={<span className="primary font-semibold text-sm">{item?.label}</span>}
                                    >
                                        <div className="flex items-center gap-2 py-1 px-2 rounded-lg">
                                            <img
                                                src={item?.paymentLogoUrl}
                                                alt="Icon"
                                                className="h-[30px] w-[30px] object-contain"
                                            />
                                            <span className={`font-semibold text-sm`}>
                                                {item?.label}
                                            </span>

                                        </div>
                                    </Select.Option>
                                ))}
                            </Select>

                            {/* Where to Deposit Dropdown */}
                            <div className="mb-4">
                                <label className="text-lg font-medium text-gray-700 block mb-2">Where to Deposit</label>
                                <Select
                                    size="large"
                                    placeholder="Select account to deposit"
                                    className="w-full"
                                    onChange={(value) => setSelectedAccount(value)}
                                    value={selectedAccount}
                                >
                                    <Select.Option value="wallet">
                                        <div className="flex items-center gap-3 py-1">
                                            <Balance color="var(--sidebarColor)" className="size-6" />

                                            <span className="text-base font-medium">Wallet</span>
                                            <span className="text-sm text-gray-500 ms-2">${walletBalance || 0}</span>
                                        </div>
                                    </Select.Option>
                                    {accounts?.map((item, index) => (
                                        <Select.Option key={index} value={item?.terminalID}>
                                            <div className="flex items-center gap-3 py-1">
                                                <img
                                                    src="/assets/images/mt5.png"
                                                    alt="MT5"
                                                    className="h-6 w-6 object-contain"
                                                />
                                                <span className="text-base font-medium">{item?.login}</span>
                                                <span className="text-sm text-gray-500 ms-2">${item?.balance || 0}</span>
                                            </div>
                                        </Select.Option>
                                    ))}
                                </Select>
                            </div>

                            {
                                isCashDeposit ?
                                    <>
                                        <Form.Item
                                            name='
                                        '
                                            label={<span className="text-lg text-gray-500 font-medium">Amount In INR <span className='text-lg primary font-semibold'>(${currencyRate?.baseCurrencyRate} = {currencyRate?.targetCurrencyRate} {currencyRate?.targetCurrency})</span></span>}
                                            rules={[{ validator: validateAmount }]}
                                        >
                                            <Input type='number' prefix="₹" addonAfter={`$ ${Number(amount)?.toFixed(2)}`} placeholder="Amount in INR" size='large' onChange={(e) => { const value = parseFloat(e.target.value) || 0; setAmount(value / currencyRate?.targetCurrencyRate) }} value={amount} />
                                        </Form.Item>
                                        {/* <div className='!m-0 text-gray-400'>Deposit amount will be $ {}</div> */}
                                    </>
                                    :
                                    <Form.Item
                                        name='amount'
                                        label={
                                            <span className="text-lg text-gray-500 font-medium">
                                                Amount In USD
                                                {paymentMethod === 'Cash Deposit' && (
                                                    <span className='text-lg primary font-semibold'>(${currencyRate?.baseCurrencyRate} = {currencyRate?.targetCurrencyRate} {currencyRate?.targetCurrency})</span>
                                                )}
                                            </span>
                                        }
                                        rules={[{ validator: validateAmount }]}
                                    >
                                        <Input type='number' placeholder="Amount in USD" size='large' onChange={(e) => setAmount(e?.target?.value)} className='py-3' />
                                    </Form.Item>
                            }
                        </Form>
                    </div>
                </div>

                {step === 2 && renderStep()}
            </div>
            <DepositRequest isRefresh={isRefresh} setIsRefresh={setIsRefresh} />
        </div>
    )
}

export default DepositMobile